import { useEffect, useState } from 'react';
import luminaEnv from 'src/env';
import { decodedToken } from 'src/graphql';
import auth0Authentication from 'src/utils/auth0Authentication';
import { decodeAuth0Token } from 'src/utils/tokenProcess';

const auth0InitParams = {
    appUrl: luminaEnv.appUrl,
    auth0: luminaEnv.auth0,
};

const useAuthentication = (shouldStart: boolean) => {
    const [loading, setLoading] = useState(true);
    // Error will most likely to be Auth0 error.
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        if (shouldStart) {
            (async () => {
                try {
                    auth0Authentication.init(auth0InitParams);
                    const newToken = await auth0Authentication.authenticate();
                    decodedToken(decodeAuth0Token(newToken));
                } catch (err: any | unknown) {
                    setError(err);
                    if (err && 'error' in err && err.error === 'login_required') {
                        console.error('redirect to login page');
                        window.location.href = `${luminaEnv.ssoV1Url}/login`;
                    }
                }

                setLoading(false);
            })();
        }
    }, [shouldStart]);

    return { loading, error };
};

export default useAuthentication;
